export const fire_denoize = require('./Fire.mp3');
export const wave_denoize = require('./Wave.mp3');
export const rain_denoize = require('./Rain.mp3');
export const creek_denoize = require('./Creek.mp3');
export const bird_denoize = require('./Bird.mp3');